var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-pagination"},[(_vm.TfTable.showPageResults)?_c('p',[_vm._v("\n    Showing "+_vm._s(_vm.countStart)+"-"+_vm._s(_vm.countEnd)+" of "+_vm._s(_vm.totalLength)+"\n  ")]):_vm._e(),(_vm.TfTable.tableRowIndexes.length)?_c('TfPagination',_vm._b({on:{"input":_vm.TfTable.onPageSelected}},'TfPagination',{
      isDisabled: !_vm.TfTable.isLoaded || _vm.TfTable.isSorting,
      totalPages: _vm.TfTable.totalPages,
      value: _vm.TfTable.localPageSelected,
      truncatedPageRange: _vm.TfTable.truncatedPageRange,
    },false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }